import { createSlice } from "@reduxjs/toolkit";
import { CargoType } from "../../cargo-types/store/slice";
import { Route } from "../../routes/store/slice";
import { Status } from "../../statuses/store/slice";
import { User } from "../../users/store/slice";
import { VehicleType } from "../../vehicle-types/store/slice";
import { FilterCode } from "../BookingFilters";
import { TrailerType } from "../../trailer-types/store/slice";

type InitialState = {
  openedFilters: FilterCode[];
  departureFrom: Date | null;
  departureTo: Date | null;
  arrivalFrom: Date | null;
  arrivalTo: Date | null;
  // startTime: Date | null;
  // endTime: Date | null;
  selectedRoutes: Route[];
  selectedStatuses: Status[];
  selectedVehicleTypes: VehicleType[];
  selectedTrailerTypes: TrailerType[];
  selectedCargoTypes: CargoType[];
  searchFilter: string;
  archived: boolean;
  createdByMe: boolean;
  imported: boolean;
  selectedCustomers: User[];
  customerName: string;

  isReady: boolean;
};

const initialState: InitialState = {
  openedFilters: [],
  departureFrom: null,
  departureTo: null,
  arrivalFrom: null,
  arrivalTo: null,
  // startTime: null,
  // endTime: null,
  selectedRoutes: [],
  selectedStatuses: [],
  selectedVehicleTypes: [],
  selectedTrailerTypes: [],
  selectedCargoTypes: [],
  searchFilter: "",
  archived: false,
  createdByMe: false,
  imported: false,
  selectedCustomers: [],
  customerName: "",

  isReady: false,
};

const bookingFilterSlice = createSlice({
  name: "bookingFilterSlice",
  initialState,
  reducers: {
    toggleFilter: (state, action) => {
      const code: FilterCode = action.payload;

      state.openedFilters = state.openedFilters.includes(code)
        ? [...state.openedFilters.filter((filterCode) => filterCode !== code)]
        : [...state.openedFilters, code];
    },
    toggleRoute: (state, action) => {
      const route: Route = action.payload;

      state.selectedRoutes = state.selectedRoutes.find(
        (selectedRoute) => selectedRoute.id === route.id
      )
        ? [
            ...state.selectedRoutes.filter(
              (selectedRoute) => selectedRoute.id !== route.id
            ),
          ]
        : [...state.selectedRoutes, route];
    },
    toggleStatus: (state, action) => {
      const status: Status = action.payload;

      state.selectedStatuses = state.selectedStatuses.find(
        (selectedStatus) => selectedStatus.code === status.code
      )
        ? [
            ...state.selectedStatuses.filter(
              (selectedStatus) => selectedStatus.code !== status.code
            ),
          ]
        : [...state.selectedStatuses, status];
    },
    setStatuses: (state, action) => {
      state.selectedStatuses = action.payload;
    },
    toggleVehicleType: (state, action) => {
      const type: VehicleType = action.payload;

      state.selectedVehicleTypes = state.selectedVehicleTypes.find(
        (selectedVehicleType) => selectedVehicleType.code === type.code
      )
        ? [
            ...state.selectedVehicleTypes.filter(
              (selectedVehicleType) => selectedVehicleType.code !== type.code
            ),
          ]
        : [...state.selectedVehicleTypes, type];
    },
    setVehicleTypes: (state, action) => {
      state.selectedVehicleTypes = action.payload;
    },
    toggleTrailerType: (state, action) => {
      const type: TrailerType = action.payload;

      state.selectedTrailerTypes = state.selectedTrailerTypes.find(
        (selectedTrailerType) => selectedTrailerType.code === type.code
      )
        ? [
            ...state.selectedTrailerTypes.filter(
              (selectedTrailerType) => selectedTrailerType.code !== type.code
            ),
          ]
        : [...state.selectedTrailerTypes, type];
    },
    setTrailerTypes: (state, action) => {
      state.selectedTrailerTypes = action.payload;
    },
    toggleCargoType: (state, action) => {
      const type: CargoType = action.payload;

      state.selectedCargoTypes = state.selectedCargoTypes.find(
        (selectedCargoType) => selectedCargoType.code === type.code
      )
        ? [
            ...state.selectedCargoTypes.filter(
              (selectedCargoType) => selectedCargoType.code !== type.code
            ),
          ]
        : [...state.selectedCargoTypes, type];
    },
    setDepartureFrom: (state, action) => {
      state.departureFrom = action.payload;
    },
    setRoutes: (state, action) => {
      state.selectedRoutes = action.payload;
    },
    setCargoTypes: (state, action) => {
      state.selectedCargoTypes = action.payload;
    },
    toggleArchived: (state) => {
      state.archived = !state.archived;
    },
    setIsArchived: (state, action) => {
      state.archived = action.payload;
    },
    toggleCreatedByMe: (state) => {
      state.createdByMe = !state.createdByMe;
    },
    setIsCreatedByMe: (state, action) => {
      state.createdByMe = action.payload;
    },
    toggleImported: (state) => {
      state.imported = !state.imported;
    },
    setIsImported: (state, action) => {
      state.imported = action.payload;
    },
    setOpenedFilters: (state, action) => {
      state.openedFilters = action.payload;
    },
    setDepartureTo: (state, action) => {
      state.departureTo = action.payload;
    },
    setArrivalFrom: (state, action) => {
      state.arrivalFrom = action.payload;
    },
    setArrivalTo: (state, action) => {
      state.arrivalTo = action.payload;
    },
    // setStartTime: (state, action) => {
    //   state.startTime = action.payload;
    // },
    // setEndTime: (state, action) => {
    //   state.endTime = action.payload;
    // },
    setSearchFilter: (state, action) => {
      state.searchFilter = action.payload;
    },
    toggleCustomer: (state, action) => {
      const customer: User = action.payload;

      state.selectedCustomers = state.selectedCustomers.find(
        (selectedCustomer) => selectedCustomer.id === customer.id
      )
        ? [
            ...state.selectedCustomers.filter(
              (selectedCustomer) => selectedCustomer.id !== customer.id
            ),
          ]
        : [...state.selectedCustomers, customer];
    },
    setCustomers: (state, action) => {
      state.selectedCustomers = action.payload;
    },
    setCustomerName: (state, action) => {
      state.customerName = action.payload;
    },
    setReady: (state, action) => {
      state.isReady = action.payload;
    },
    reset: () => initialState,
  },
});

export default bookingFilterSlice;
